module.exports = __webpack_public_path__ + "assets/img/student.fc0b0dda.png";